import { render, staticRenderFns } from "./agreement2.vue?vue&type=template&id=7121d698&scoped=true"
import script from "./agreement2.vue?vue&type=script&lang=js"
export * from "./agreement2.vue?vue&type=script&lang=js"
import style0 from "./agreement2.vue?vue&type=style&index=0&id=7121d698&prod&scoped=true&lang=less"
import style1 from "./agreement2.vue?vue&type=style&index=1&id=7121d698&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7121d698",
  null
  
)

export default component.exports